import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
function ClockIcon({ className, type }) {
    if (type === 'solid') {
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: getClassName(className), viewBox: "0 0 20 20", fill: "currentColor" },
            React.createElement("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z", clipRule: "evenodd" })));
    }
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: getClassName(className), fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2 },
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" })));
}
ClockIcon.propTypes = {
    type: PropTypes.oneOf(['solid', 'outline']),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
ClockIcon.defaultProps = {
    type: 'solid',
    className: 'w-6 h-6',
};
export default ClockIcon;
